module.exports = __webpack_public_path__ + "media/images/pic/brodno/brodno_teenagers-e146beaf86958322c36e19e36b026809.svg";